import { fetcherWithToken } from '@/shared/api/fetcher';
import useSWRMutation from 'swr/mutation';

async function updateUser(url: string, { arg }: { arg: FormData }) {
  return fetcherWithToken(url, {
    method: 'POST',
    body: arg,
  });
}

export const useProfile = () => {
  const { trigger } = useSWRMutation('/profile/updateProfileData', updateUser);

  return {
    trigger,
  };
};
